import { render, staticRenderFns } from "./LogoutModalElement.vue?vue&type=template&id=9f38a7b4&scoped=true&"
import script from "./LogoutModalElement.vue?vue&type=script&lang=js&"
export * from "./LogoutModalElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f38a7b4",
  null
  
)

export default component.exports